import { useUserData } from "../services/contexts/UserDataContext";

export default function useCanAccessProfessionalCoaching(): boolean {
  const { data: user } = useUserData();

  return Boolean(user?.organisation?.plan?.accessCareerCoaching);
}
